import React, { Component } from 'react'

class CalifEstudiantes extends Component {
    state = {  }
    render() { 
        return (
            <div>Reporte Calificaciones</div>
        );
    }
}
 
export default CalifEstudiantes;


// WEBPACK FOOTER //
// ./src/components/Reportes/CalifEstudiantes.jsx